import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import type { ColumnDataSourceKeyValueDataType } from "../../../../../../../../api/infrastructure/table.formatter";
import { showToast } from "../../../../../../../shared/global-tools/toast-system";
import Icon from "../../../../../../utils/Icons/Icon";
import "./TableColumnEnumForm.scss";

interface TableColumnEnumFormProps {
  initialKeyValues?: ColumnDataSourceKeyValueDataType[];
  close(): void;
  onChange(keyValues: ColumnDataSourceKeyValueDataType[]): void;
  onCancel?(): void;
}

export default function TableColumnEnumForm({
  initialKeyValues,
  close,
  onChange,
  onCancel,
}: TableColumnEnumFormProps) {
  const [keyValues, setKeyValues] = useState<ColumnDataSourceKeyValueDataType[] | undefined>();
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");

  const handleKeyValueSubmit = () => {
    const isKeyTaken = keyValues?.some((kv) => kv.key === key);
    if (isKeyTaken) {
      showToast("La clé est déjà utilisée", { severity: "warn" });
      return;
    }
    setKeyValues([...(keyValues || []), { key, value }]);
    setKey("");
    setValue("");
  };

  const handleSave = () => {
    if (keyValues) onChange(keyValues);
    close();
  };
  const handleRemoveKeyValue = (key: string) => {
    if (!keyValues) return;
    setKeyValues(keyValues.filter((kv) => kv.key !== key));
  };

  useEffect(() => {
    setKeyValues(initialKeyValues);
  }, [initialKeyValues]);

  return (
    <div className="TableColumnEnumForm">
      <div className="TableColumnEnumForm-header">
        <h2 className="TableColumnEnumForm-headerTitle">Configuration des options</h2>
        <p className="TableColumnEnumForm-headerSubtitle">Gérer les options de configuration</p>
      </div>

      <div className="TableColumnEnumForm-body">
        <form
          className="TableColumnEnumForm-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleKeyValueSubmit();
          }}
        >
          <label className="Field">
            {/* TODO: standardize styles */}
            <span className="Field-label" style={{ fontWeight: 500, fontSize: "13px" }}>
              Clé
            </span>
            <InputText
              className="Field-input small TableColumnEnumForm-input w-full"
              value={key}
              onChange={(e) => {
                setKey(e.target.value);
              }}
              required
            />
          </label>
          <label className="Field">
            {/* TODO: standardize styles */}
            <span className="Field-label" style={{ fontWeight: 500, fontSize: "13px" }}>
              Valeur
            </span>
            <InputText
              className="Field-input small TableColumnEnumForm-input w-full"
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              required
            />
          </label>

          <div className="TableColumnEnumForm-formActions">
            <Button
              type="button"
              label="Annuler"
              className="TableColumnEnumForm-btn small Btn secondary outlined"
            />
            <Button
              type="submit"
              label="Ajouter"
              className="TableColumnEnumForm-btn small Btn primary"
            />
          </div>
        </form>

        <div className="TableColumnEnumForm-preview">
          <div className="TableColumnEnumForm-previewHeader">
            <h3>Aperçu des valeurs</h3>
            <div className="TableColumnEnumForm-previewCount">
              {!keyValues ? 0 : keyValues.length} option
              {keyValues && keyValues.length > 1 ? "s" : ""}
            </div>
          </div>

          <ul style={{ display: "flex", flexDirection: "column", gap: "21px" }}>
            {keyValues?.map((v) => (
              <li key={v.key}>
                <div className="PreviewItem">
                  <div className="PreviewItem-content">
                    <h3 className="PreviewItem-key">{v.key}</h3>
                    <p className="PreviewItem-value">{v.value}</p>
                  </div>

                  <button
                    type="button"
                    className="IconBtn"
                    onClick={() => handleRemoveKeyValue(v.key)}
                  >
                    <Icon name="trash" color="#EF0404" width={17} height={17} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="TableColumnEnumForm-rootActions">
          <Button
            type="button"
            label="Annuler"
            className="TableColumnEnumForm-btn Btn secondary outlined"
            onClick={() => {
              onCancel?.();
              close();
            }}
          />
          <Button
            type="button"
            label="Enregistrer"
            className="TableColumnEnumForm-btn Btn primary"
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
}
